import { APIClient } from "api/api_helper";
import { CRYOVIAL_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const SampleSeparationApiService = {
    // SELECT ALL SAMPLE SEPARATION
    selectAll: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const periodVal = payload_data.period && payload_data.period !== "ALL" ? String(payload_data.period) : null;
        const tpVal = payload_data.timepoint && (Array.isArray(payload_data.timepoint) ? !payload_data.timepoint.includes("ALL") && payload_data.timepoint.length === 1 ? String(payload_data.timepoint[0]) : null : payload_data.timepoint !== "ALL" ? String(payload_data.timepoint) : null);
        const aliVal = payload_data.aliquot && (Array.isArray(payload_data.aliquot) ? !payload_data.aliquot.includes("ALL") && payload_data.aliquot.length === 1 ? String(payload_data.aliquot[0]) : null : payload_data.aliquot !== "ALL" ? String(payload_data.aliquot) : null);

        const payload = {
            studyid: payload_data.studyid,
            period_number: periodVal,
            timepoint_number: tpVal,
            aliquot_number: aliVal,
            currentpage: payload_data.currentpage ?? null,
            pagesize: payload_data.pagesize ?? null,
            searchtext: payload_data.searchtext || null,
            status: payload_data.status || "A",
        };
        return api.create(CRYOVIAL_LABEL_API.CRYOVIAL_LABEL_API + "SelectAll", payload);
    },
    // UPDATE CRYOVIAL LABEL PRINT
    updateLabel: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            sampleseparation: payload_data.sampleseparation || [],
            printby: user?.userid,
        };
        return api.create(CRYOVIAL_LABEL_API.CRYOVIAL_LABEL_API + "Update", payload);
    },
    // INSERT CRYOVIAL LABEL REPRINT HISTORY
    insertHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            createdby: user?.userid,
            reasonforreprint: payload_data.reasonforreprint,
            additionalcomments: payload_data.additionalcomments,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(CRYOVIAL_LABEL_API.CRYOVIAL_LABEL_HISTORY_API + "Insert", payload);
    },
};